import React from "react";

import IconMessage from "../../../common/IconMessage";
import NoNotificationsIcon from "../../../landingPage/pages/Notifications/assets/no-notifications.svg";

const StrategyNoNotificationsYetDesktop = ({ title, description }) => (
  <IconMessage
    imageSrc={NoNotificationsIcon}
    imageHeight={110}
    imageWidth={110}
    title={title}
    description={description}
  />
);

export default StrategyNoNotificationsYetDesktop;
